function MyTab(el)
{
    this.el=el;
    this.$el=$(el);
    this.tabs=[];
    this.init();
    return this;
}

MyTab.prototype.init=function()
{
    console.log("my-tab-init");
    var tabs=this.$el.find("a");
    var realTabs=[];
    var tNameTo={};
    $(tabs).each(function(i,tab){
        tNameTo[$(tab).attr("data-my-tab")]=i;
        var tb={menu:$(tab),tab:null};
        tb.tab=$("."+$(tab).attr("data-my-tab"));
        $(tab).on("click",function(){
            window.location.hash=$(tab).attr("data-my-tab");
            this.activeTab(i);
            return false;
        }.bind(this));
        realTabs.push(tb);
    }.bind(this));

    var hasActiveTab=false;
    //process tabs
    for(var i in realTabs)
    {
        if(realTabs[i].tab.hasClass("my-tab-active"))
        {
            realTabs[i].menu.parent().addClass("active");
            hasActiveTab=true;
        }
    }

    this.tabs=realTabs;

    if(window.location.hash.length && typeof tNameTo[window.location.hash.substr(1)]!='undefined') {
        this.activeTab(tNameTo[window.location.hash.substr(1)]);
    }
};

MyTab.prototype.cleanActive=function()
{
    for(var i in this.tabs)
    {
        this.tabs[i].menu.parent().removeClass("active");
        this.tabs[i].tab.removeClass("my-tab-active");
    }
}

MyTab.prototype.activeTab=function(i)
{
    this.cleanActive();
    this.tabs[i].menu.parent().addClass("active");
    this.tabs[i].tab.addClass("my-tab-active");
}



$(function(){
    $(".my-tab-menu").each(function(i,menu){
        menu.tab=new MyTab(menu);
    });

    $("a[data-toggle='tab']").on("click",function(){
        var select=$(this).attr("data-target").slice(1);
        $(this).closest('ul').find("[data-toggle='tab']").each(function(i,item) {
            var select=$(item).attr("data-target").slice(1);
            console.log("test", select);
            $(".extra-tab."+select).removeClass("is_active").removeClass("active");
        });

        $("."+select).addClass("is_active");
    });
});